var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBadgeStar = function SvgBadgeStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.7 12.434 1.665 3.319h2.85a.775.775 0 0 1 .544 1.328l-2.433 1.669 1.266 3.393a.789.789 0 0 1-1.11 1L12 21.184l-3.491 1.961a.789.789 0 0 1-1.11-1L9 18.75l-2.76-1.659a.781.781 0 0 1 .548-1.338h2.835l1.665-3.319a.793.793 0 0 1 1.412 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25.75a1.5 1.5 0 0 0-1.5 1.5v5.228A1.5 1.5 0 0 0 7.378 8.7L12 12l4.622-3.3a1.5 1.5 0 0 0 .628-1.221V2.25a1.5 1.5 0 0 0-1.5-1.5zm3.75 0V12"
  })));
};
export default SvgBadgeStar;